// API client for the EV Performance & Range Simulator. All simulation/physics logic
// lives server-side (backend/simulation/, backend/api/simulation_routes.py) — this file
// only makes requests and returns response data, mirroring the pattern in toolsApi.js.
// Public endpoints, no auth token attached.
import axios from 'axios';

const SIMULATE_API_URL = process.env.REACT_APP_BACKEND_URL + '/api/simulate';

async function post(path, body) {
  try {
    const response = await axios.post(`${SIMULATE_API_URL}${path}`, body);
    return response.data;
  } catch (err) {
    const detail = err.response?.data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d) => d.msg).join('; ')
      : (detail || err.message || 'Request failed.');
    throw new Error(message);
  }
}

export const simulationApi = {
  runPerformance: (payload) => post('/performance', payload),
  sizeBattery: (payload) => post('/battery/size', payload),
  runDriveCycle: (payload) => post('/drive-cycle', payload),
  runFull: (payload) => post('/full', payload),
  runCharging: (payload) => post('/charging', payload),
  runRegenBlending: (payload) => post('/regen-blending', payload),
  runBatteryThermal: (payload) => post('/battery-thermal', payload),
  runHevEnergyManagement: (payload) => post('/hev-energy-management', payload),
};
